import { render, staticRenderFns } from "./CrossSellTable.vue?vue&type=template&id=252bb63b&scoped=true"
import script from "./CrossSellTable.vue?vue&type=script&lang=js"
export * from "./CrossSellTable.vue?vue&type=script&lang=js"
import style0 from "./CrossSellTable.vue?vue&type=style&index=0&id=252bb63b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bb63b",
  null
  
)

export default component.exports